<template>
    <section>
        <form v-if="success == false" @submit="register" id="register" class="form-register" method="post" action="/auth/register/">
            <div class="form-wrapper">
                <div class="form-row half">
                    <div class="form-group mb-4">
                        <input v-bind:class="{error: error}" v-model="firstname" type="text" placeholder="Firstname" class="form-control" required />
                    </div>
                    <div class="form-group mb-4">
                        <input v-bind:class="{error: error}" v-model="lastname" type="text" placeholder="Lastname" class="form-control" required />
                    </div>
                </div>
                <div class="form-row half">
                    <div class="form-group mb-4">
                        <input v-bind:class="{error: error}" v-model="email" type="email" placeholder="Email" class="form-control" required />
                    </div>
                    <div class="form-group mb-4">
                        <input v-bind:class="{error: error}" v-model="phone" type="tel" placeholder="Phone" class="form-control" required />
                    </div>
                </div>
                <div class="form-row half">
                    <div class="form-group mb-4">
                        <input v-bind:class="{error: error}" v-model="company" type="text" placeholder="Company" class="form-control" required />
                    </div>
                    <div class="form-group mb-4">
                        <input v-bind:class="{error: error}" v-model="website" type="text" placeholder="Website" class="form-control" required />
                    </div>
                </div>
                <div class="form-row half mb-4">
                    <div class="form-group">
                        <input v-bind:class="{error: error}" v-model="password" type="password" placeholder="Password" class="form-control" required />
                    </div>
                </div>
                <p v-if="success == false" class="text-center mb-4"><i>{{ message }}</i></p>
                <button type="submit" class="btn btn-lg btn-primary center" v-bind:class="{load: loading}">
                    Apply
                    <div class="loading"></div>
                </button>
                <div class="mt-3 d-flex flex-column align-items-center text-center login-links">
                    <router-link :to="{name: 'login'}">
                        <small class="d-flex align-items-center"><svg viewBox="0 0 512 512" class="back-arrow mr-1"><path d="m217.9 256 127.1-127c9.4-9.4 9.4-24.6 0-33.9-9.4-9.4-24.6-9.3-34 0l-144 143.9c-9.1 9.1-9.3 23.7-.7 33.1l144.6 144.9c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9z"/></svg> Back to Login</small>
                    </router-link>
                </div>
            </div>
        </form>
        <p v-if="success" class="text-center"><i>{{ message }}</i></p>
        <div v-if="success" class="mt-3 d-flex flex-column align-items-center text-center login-links">
            <router-link :to="{name: 'login'}">
                <small class="d-flex align-items-center"><svg viewBox="0 0 512 512" class="back-arrow mr-1"><path d="m217.9 256 127.1-127c9.4-9.4 9.4-24.6 0-33.9-9.4-9.4-24.6-9.3-34 0l-144 143.9c-9.1 9.1-9.3 23.7-.7 33.1l144.6 144.9c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9z"/></svg> Back to Login</small>
            </router-link>
        </div>
    </section>
</template>

<script>
import {hashPassword} from '@/methods/HashPassword.js';

export default {
    name: 'AuthRegister',
    metaInfo: {
        title: 'Register'
    },
    data () {
        return {
            email: null,
            password: null,
            firstname: null,
            lastname: null,
            phone: null,
            company: null,
            website: null,
            success: false,
            message: null,
            error: false,
            loading: false
        }
    },
    methods:{
        register: function (e) {
            e.preventDefault();
            this.loading = true;
            axios.post(process.env.VUE_APP_API_URL + '/api/user/', {
                email: this.email,
                password: hashPassword.bcrypt(this.password),
                firstname: this.firstname,
                lastname: this.lastname,
                phone: this.phone,
                company: this.company,
                website: this.website
            })
            .then(response => (
                this.loading = false,
                this.success = response.data['success'],
                this.message = response.data['message']
            ))
            .catch(error => (
                this.loading = false,
                this.error = true
            ))
        }
    }
}
</script>
